module.exports = __webpack_public_path__ + "static/media/FeedbackExpiredKTMNew.f49831ab.svg";